export default __webpack_public_path__ + "static/media/see-transfers-made.5bcfdd8d.svg";